module.exports = __webpack_public_path__ + "static/media/blog-page-1.3326af4a.jpg";